export const COMMON_CONSTANTS = {
  appointmentsDefaultCountry: 'AUS',
  appointmentsDefaultState: 'QLD',
  dateFormats: {
    displayDate: 'dd MMM yyyy',
    isoDate: 'YYYY-MM-DD'
  },
  raptorFlows: [
    'appointmentFlow',
    'cancellationFlow',
    'endorsementFlow',
    'quoteFlow',
    'prerenewalFlow',
    'updatePaymentFlow'
  ]
}
